import styled from "styled-components";

export const PmsPromptConfigPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: ${props => props.theme.colors.white};
  height: calc(100vh - 48px);
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  background-color: ${(props) => props.theme.colors.white};
  height: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
`;
